import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LanguageSelector from '@/components/ui/LanguageSelector';
import Footer from '../ui/Footer';

export default function ProfileNotFound() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <header className="bg-gray-900">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex items-center justify-between">
            <Link to="/" className="text-xl font-bold">
              <span className="text-white">MyPink</span>
              <span className="text-mk-pink-400">Contact</span>
            </Link>
            <LanguageSelector variant="light" />
          </div>
        </div>
      </header>
      <div className="flex-grow flex items-center justify-center">
        <div className="text-center px-4">
          <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-gray-100 flex items-center justify-center">
            <svg
              className="w-10 h-10 text-gray-400"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
              />
            </svg>
          </div>
          <h1 className="text-2xl font-bold text-gray-800 mb-2">
            {t('profile.notFound.title')}
          </h1>
          <p className="text-gray-600 mb-6">
            {t('profile.notFound.message')}
          </p>
          <Link
            to="/"
            className="inline-block px-6 py-3 bg-mk-pink-600 text-white font-semibold rounded-full hover:bg-mk-pink-700 transition-colors"
          >
            {t('profile.notFound.cta')}
          </Link>
        </div>
      </div>
      <Footer showCta={false} />
    </div>
  );
}
